import {useEffect, useState} from "react";

export const useDynamicStep = (isDynamicStep: boolean, value: number, defaultStep: number) => {
    if (!isDynamicStep) {
        return defaultStep;
    }

    const [step, setStep] = useState(defaultStep);

    useEffect(() => {
        if (value <= 1000000 && step !== 50000) {
            setStep(50000);
        }
        if (value > 1000000 && value <= 2500000 && step !== 100000) {
            setStep(100000);
        }

        if (value > 2500000 && step !== 250000) {
            setStep(250000);
        }
    }, [value]);

    return step;
};
import {useEffect, useState} from "react";

export const useDynamicStep = (isDynamicStep: boolean, value: number, defaultStep: number) => {
    if (!isDynamicStep) {
        return defaultStep;
    }

    const [step, setStep] = useState(defaultStep);

    useEffect(() => {
        if (value <= 1000000 && step !== 50000) {
            setStep(50000);
        }
        if (value > 1000000 && value <= 2500000 && step !== 100000) {
            setStep(100000);
        }

        if (value > 2500000 && step !== 250000) {
            setStep(250000);
        }
    }, [value]);

    return step;
};
